import React from 'react';

const Feature = () => {
  return (
    <>
      {/* <!-- features cards --> */}
      <div className="mt-4 w-100 w-sm-25">
        <div
          className="feature-card h-100 p-8 border-bottom rounded-3 d-flex flex-column
                        align-items-center mx-sm-2 p-sm-3 p-md-8 "
          style={{ backgroundColor: '#f6f4ef' }}
        >
          <div
            className="badge text-bg-light rounded-pill p-2"
            style={{ width: '3rem' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="2rem"
              height="2rem"
              style={{ color: '#edd969' }}
              viewBox="0 0 128 128"
            >
              <path
                fill="#fff"
                d="M64.1,4c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.4,0c21.8,0,40.4,13.9,47.3,33.4c1.8,5.2,7.7,37.1,7.7,37.1c0.7,2.1,0.1,4.4-1.4,6l-2.8,2.8c-1.1,1.1-1.7,2.6-1.7,4.2V102c0,4.4-3.6,8-8,8h-8c-5.5,0-10,4.5-10,10v7H77H64L64.1,4C64,4,64,4,64.1,4z"
              ></path>
              <path
                fill="#444b54"
                d="M87.9 127c-1.7 0-3-1.3-3-3v-4c0-7.2 5.8-13 13-13h8c2.8 0 5-2.2 5-5V87.5c0-2.4.9-4.6 2.5-6.3l2.8-2.8c.8-.8 1-1.9.7-3 0-.1-.1-.2-.1-.3l-6.4-30.7c-2.9-14.1-11.7-25 w-sm-100.8-24-32.2C80.4 9.1 73.8 7.4 67 7v102c0 1.7-1.3 3-3 3s-3-1.3-3-3V4c0-.9.4-1.7 1.1-2.3C62.7 1.2 63.4 1 64.2 1c8.7-.1 17.4 1.9 25 5.9 13.9 7.2 23.8 20.4 27.1 36.3l6.4 30.6c.9 3.1.1 6.5-2.2 8.8l-2.8 2.8c-.5.6-.8 1.3-.8 2.1V102c0 6.1-4.9 11-11 11h-8c-3.9 0-7 3.1-7 7v4C90.9 125.7 89.5 127 87.9 127zM64 4L64 4 64 4zM64 127c-.2 0-.4 0-.6-.1-.2 0-.4-.1-.6-.2-.2-.1-.3-.2-.5-.3-.2-.1-.3-.2-.5-.4-.6-.6-.9-1.3-.9-2.1 0-.2 0-.4.1-.6 0-.2.1-.4.2-.6.1-.2.2-.3.3-.5.1-.2.2-.3.4-.4s.3-.3.5-.4c.2-.1.3-.2.5-.3.2-.1.4-.1.6-.2.4-.1.8-.1 1.2 0 .2 0 .4.1.6.2.2.1.4.2.5.3.2.1.3.2.5.4.1.1.3.3.4.4.1.2.2.3.3.5.1.2.1.4.2.6 0 .2.1.4.1.6 0 .8-.3 1.6-.9 2.1-.1.1-.3.3-.5.4-.2.1-.3.2-.5.3-.2.1-.4.1-.6.2C64.4 127 64.2 127 64 127z"
              ></path>
              <path
                fill="#fff"
                d="M47 12A7 7 0 1 0 47 26 7 7 0 1 0 47 12zM47 102A7 7 0 1 0 47 116 7 7 0 1 0 47 102zM12 57A7 7 0 1 0 12 71 7 7 0 1 0 12 57zM21 26A7 7 0 1 0 21 40 7 7 0 1 0 21 26zM21 88A7 7 0 1 0 21 102 7 7 0 1 0 21 88z"
              ></path>
              <path
                fill="#71c2ff"
                d="M47 29c-5.5 0-10-4.5-10-10S41.5 9 47 9s10 4.5 10 10S52.5 29 47 29zM47 15c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4S49.2 15 47 15zM52 76H37c-.8 0-1.6.3-2.1.9l-9.3 9.3c-1.4-.7-3-1.1-4.6-1.1-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10c0-1.7-.4-3.2-1.1-4.6l8.4-8.4H52c1.7 0 3-1.3 3-3S53.7 76 52 76zM21 99c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4S23.2 99 21 99zM52 61H21.5c-1.3-4.1-5.1-7-9.5-7C6.5 54 2 58.5 2 64s4.5 10 10 10c4.5 0 8.3-2.9 9.5-7H52c1.7 0 3-1.3 3-3S53.7 61 52 61zM12 68c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4S14.2 68 12 68zM21 43c1.7 0 3.2-.4 4.6-1.1l9.3 9.3c.6.6 1.3.9 2.1.9h15c1.7 0 3-1.3 3-3s-1.3-3-3-3H38.2l-8.4-8.4c.7-1.4 1.1-3 1.1-4.6 0-5.5-4.5-10-10-10s-10 4.5-10 10S15.5 43 21 43zM21 29c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4S18.8 29 21 29z"
              ></path>
              <g>
                <path
                  fill="#71c2ff"
                  d="M47,119c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10S52.5,119,47,119z M47,105c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S49.2,105,47,105z"
                ></path>
              </g>
            </svg>
          </div>
          <div className="mt-4 fw-semibold">AI-Generated Quizzes</div>
          <div className="text-center mt-3  fs-6">
            Our AI-powered feature generates quizzes on various difficulty
            levels and subjects, tailored to your institution's curriculum.
          </div>
        </div>
      </div>

      <div className="mt-4 w-100 w-sm-25">
        <div
          className="feature-card h-100 p-8 border-bottom rounded-3 d-flex flex-column
                        align-items-center mx-sm-2 p-sm-3 p-md-8 "
          style={{ backgroundColor: '#f6f4ef' }}
        >
          <div
            className="badge text-bg-light rounded-pill p-2"
            style={{ width: '3rem' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="2rem"
              height="2rem"
              style={{ color: '#edd969' }}
              viewBox="0 0 24 24"
            >
              <path d="M 12 2 C 8.741068 2 5.8486894 3.5773875 4.0214844 6 L 4 6 L 4 6.0273438 C 2.7499527 7.6966931 2 9.7603852 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 15 4.5839844 C 17.935098 5.7673596 20 8.6326468 20 12 C 20 14.087831 19.200587 15.978318 17.898438 17.400391 C 17.642583 16.590687 16.894567 16 16 16 C 15.448 16 15 15.552 15 15 L 15 13 C 15 12.448 14.552 12 14 12 L 10 12 C 9.448 12 9 11.552 9 11 C 9 10.448 9.448 10 10 10 C 10.552 10 11 9.552 11 9 L 11 8 C 11 7.448 11.448 7 12 7 L 13 7 C 14.105 7 15 6.105 15 5 L 15 4.5839844 z M 4.2070312 10.207031 L 9 15 L 9 16 C 9 17.105 9.895 18 11 18 L 11 19.931641 C 7.0457719 19.441154 4 16.090654 4 12 C 4 11.382188 4.0755242 10.784034 4.2070312 10.207031 z"></path>
            </svg>
          </div>
          <div className="mt-4 fw-semibold">Public Quizzes</div>
          <div className="text-center mt-3  fs-6">
            Practice popular topics and challenge yourself with public quizzes,
            competing with other learners to test your knowledge.
          </div>
        </div>
      </div>
      <div className="mt-4 w-100 w-sm-25">
        <div
          className="feature-card h-100 p-8  border-bottom rounded-3  d-flex flex-column
                        align-items-center mx-sm-2 p-sm-3 p-md-8 "
          style={{ backgroundColor: '#f6f4ef' }}
        >
          <div
            className="badge text-bg-light rounded-pill p-2"
            style={{ width: '3rem' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="2rem"
              height="2rem"
              style={{ color: '#edd969' }}
              viewBox="0 0 24 24"
            >
              <path d="M 7 1 C 6.448 1 6 1.448 6 2 L 6 3 L 5 3 C 3.9 3 3 3.9 3 5 L 3 19 C 3 20.1 3.9 21 5 21 L 19 21 C 20.1 21 21 20.1 21 19 L 21 5 C 21 3.9 20.1 3 19 3 L 18 3 L 18 2 C 18 1.448 17.552 1 17 1 C 16.448 1 16 1.448 16 2 L 16 3 L 8 3 L 8 2 C 8 1.448 7.552 1 7 1 z M 5 8 L 19 8 L 19 19 L 5 19 L 5 8 z M 14 13 C 13.448 13 13 13.448 13 14 L 13 16 C 13 16.552 13.448 17 14 17 L 16 17 C 16.552 17 17 16.552 17 16 L 17 14 C 17 13.448 16.552 13 16 13 L 14 13 z"></path>
            </svg>
          </div>
          <div className="mt-4 fw-semibold">Scheduled Quizzes</div>
          <div className="text-center mt-3  fs-6">
            Stay organized and motivated with scheduled quizzes, ensuring
            regular practice and progress tracking.
          </div>
        </div>
      </div>
      <div className="mt-4 w-100 w-sm-25">
        <div
          className="feature-card h-100 p-8  border-bottom rounded-3 d-flex flex-column
                        align-items-center mx-sm-2 p-sm-3 p-md-8 "
          style={{ backgroundColor: '#f6f4ef' }}
        >
          <div
            className="badge text-bg-light rounded-pill p-2"
            style={{ width: '3rem' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="2rem"
              height="2rem"
              style={{ color: '#edd969' }}
              viewBox="0 0 50 50"
            >
              <path d="M 7.90625 1.96875 C 7.863281 1.976563 7.820313 1.988281 7.78125 2 C 7.316406 2.105469 6.988281 2.523438 7 3 L 7 12 L 16 12 C 16.359375 12.003906 16.695313 11.816406 16.878906 11.503906 C 17.058594 11.191406 17.058594 10.808594 16.878906 10.496094 C 16.695313 10.183594 16.359375 9.996094 16 10 L 10.3125 10 C 14.101563 6.292969 19.277344 4 25 4 C 36.609375 4 46 13.390625 46 25 C 46 36.609375 36.609375 46 25 46 C 13.390625 46 4 36.609375 4 25 C 4 21.527344 4.855469 18.257813 6.34375 15.375 L 4.5625 14.46875 C 2.929688 17.625 2 21.207031 2 25 C 2 37.691406 12.308594 48 25 48 C 37.691406 48 48 37.691406 48 25 C 48 12.308594 37.691406 2 25 2 C 18.773438 2 13.140625 4.503906 9 8.53125 L 9 3 C 9.011719 2.710938 8.894531 2.433594 8.6875 2.238281 C 8.476563 2.039063 8.191406 1.941406 7.90625 1.96875 Z M 25 5 C 24.449219 5 24 5.449219 24 6 C 24 6.550781 24.449219 7 25 7 C 25.550781 7 26 6.550781 26 6 C 26 5.449219 25.550781 5 25 5 Z M 34.5 7.53125 C 33.949219 7.53125 33.5 7.980469 33.5 8.53125 C 33.5 9.082031 33.949219 9.53125 34.5 9.53125 C 35.050781 9.53125 35.5 9.082031 35.5 8.53125 C 35.5 7.980469 35.050781 7.53125 34.5 7.53125 Z M 41.46875 14.5 C 40.917969 14.5 40.46875 14.949219 40.46875 15.5 C 40.46875 16.050781 40.917969 16.5 41.46875 16.5 C 42.019531 16.5 42.46875 16.050781 42.46875 15.5 C 42.46875 14.949219 42.019531 14.5 41.46875 14.5 Z M 29.78125 16.90625 C 27.007813 16.90625 25.0625 18.714844 25.0625 21.3125 L 25.0625 21.34375 L 27.125 21.34375 L 27.125 21.3125 C 27.125 19.808594 28.164063 18.8125 29.71875 18.8125 C 31.171875 18.8125 32.28125 19.773438 32.28125 21.0625 C 32.28125 22.097656 31.824219 22.847656 29.9375 24.8125 L 25.15625 29.75 L 25.15625 31.34375 L 34.65625 31.34375 L 34.65625 29.375 L 28.21875 29.375 L 28.21875 29.21875 L 31.34375 26.03125 C 33.707031 23.640625 34.4375 22.429688 34.4375 20.9375 C 34.4375 18.613281 32.457031 16.90625 29.78125 16.90625 Z M 18.90625 17.25 L 15.1875 19.875 L 15.1875 22.09375 L 18.71875 19.59375 L 18.90625 19.59375 L 18.90625 31.34375 L 21.09375 31.34375 L 21.09375 17.25 Z M 6 24 C 5.449219 24 5 24.449219 5 25 C 5 25.550781 5.449219 26 6 26 C 6.550781 26 7 25.550781 7 25 C 7 24.449219 6.550781 24 6 24 Z M 44 24 C 43.449219 24 43 24.449219 43 25 C 43 25.550781 43.449219 26 44 26 C 44.550781 26 45 25.550781 45 25 C 45 24.449219 44.550781 24 44 24 Z M 8.53125 33.5 C 7.980469 33.5 7.53125 33.949219 7.53125 34.5 C 7.53125 35.050781 7.980469 35.5 8.53125 35.5 C 9.082031 35.5 9.53125 35.050781 9.53125 34.5 C 9.53125 33.949219 9.082031 33.5 8.53125 33.5 Z M 41.46875 33.5 C 40.917969 33.5 40.46875 33.949219 40.46875 34.5 C 40.46875 35.050781 40.917969 35.5 41.46875 35.5 C 42.019531 35.5 42.46875 35.050781 42.46875 34.5 C 42.46875 33.949219 42.019531 33.5 41.46875 33.5 Z M 15.5 40.46875 C 14.949219 40.46875 14.5 40.917969 14.5 41.46875 C 14.5 42.019531 14.949219 42.46875 15.5 42.46875 C 16.050781 42.46875 16.5 42.019531 16.5 41.46875 C 16.5 40.917969 16.050781 40.46875 15.5 40.46875 Z M 34.5 40.46875 C 33.949219 40.46875 33.5 40.917969 33.5 41.46875 C 33.5 42.019531 33.949219 42.46875 34.5 42.46875 C 35.050781 42.46875 35.5 42.019531 35.5 41.46875 C 35.5 40.917969 35.050781 40.46875 34.5 40.46875 Z M 25 43 C 24.449219 43 24 43.449219 24 44 C 24 44.550781 24.449219 45 25 45 C 25.550781 45 26 44.550781 26 44 C 26 43.449219 25.550781 43 25 43 Z"></path>
            </svg>
          </div>
          <div className="mt-4 fw-semibold">Timed Quizzes</div>
          <div className="text-center mt-3  fs-6">
            Test your knowledge and improve your speed with timed quizzes,
            simulating real exam conditions.
          </div>
        </div>
      </div>
    </>
  );
};

export default Feature;
